module.exports = __webpack_public_path__ + "static/img/10.4aa9c2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/10.png
// module id = cJPy
// module chunks = 0